import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { PageHeader } from '@/components/page-header'
import { ClientRegistrationForm } from '@/features/clients/client-registration-form'
import { requirePermission } from '@/lib/route-guards'
import { ROUTES } from '@/lib/routes'

export const Route = createFileRoute('/_app/clients/new')({
  beforeLoad: requirePermission('clients:write'),
  component: ClientsNewPage,
})

/** Registro de un cliente nuevo en pasos. */
function ClientsNewPage() {
  return (
    <div className="mx-auto max-w-6xl space-y-6">
      <PageHeader
        eyebrow={
          <Link to={ROUTES.clients} className="inline-flex items-center gap-1 hover:text-foreground">
            <ArrowLeft className="size-3.5" aria-hidden /> Clientes
          </Link>
        }
        title="Nuevo cliente"
        description="Registre al cliente con su DPI. Tenga a mano el documento y lea al cliente el aviso de privacidad."
      />
      <ClientRegistrationForm />
    </div>
  )
}
